// C-Tribe Startup Alpha 2027 (revived from 2019). Kept free of client-only
// imports so the form, the thank-you screen and the server emails share it.
// Owner-approved terms: free for accepted startups (2 Tech Passes plus one
// exhibit day on Village Expo Builders' Row); founded 2022 or later; raised
// under $1M CAD; live product or MVP and a website; rolling, closes May 15, 2027.
export const STARTUP_ALPHA_FORM_SLUG = "tech/startup-alpha";
export const STARTUP_ALPHA_NAME = "C-Tribe Startup Alpha";
export const STARTUP_ALPHA_CLOSES_ON = "May 15, 2027";
// End of day in Edmonton (MDT, UTC-6, in May).
export const STARTUP_ALPHA_CLOSES_AT = "2027-05-15T23:59:59-06:00";

export const STARTUP_ALPHA_MIN_YEAR = 2022;
export const STARTUP_ALPHA_MAX_YEAR = 2027;
export const STARTUP_ALPHA_YEAR_ERROR = "Startup Alpha is for companies founded in 2022 or later.";
export const STARTUP_ALPHA_RAISED_ERROR = "Startup Alpha is for startups that have raised under $1M CAD.";

export const startupAlphaRaisedOptions = [
  "Nothing yet",
  "Under $250,000",
  "$250,000 to $999,999",
  "$1,000,000 or more",
] as const;
// Selecting this answer cannot be submitted (see startup-alpha-form.ts).
export const STARTUP_ALPHA_INELIGIBLE_RAISE = "$1,000,000 or more";

export const startupAlphaStageOptions = [
  "Pre-seed (MVP live, no revenue yet)",
  "Seed (we have a minimal viable product)",
  "Early revenue (paying customers)",
  "Scaling (growing revenue)",
] as const;

export const startupAlphaEmergingTechOptions = [
  "Artificial intelligence and machine learning",
  "Blockchain and Web3",
  "AR, VR and spatial computing",
  "IoT and connected hardware",
  "Robotics and automation",
  "Clean tech and energy",
  "Quantum",
  "Other",
] as const;

export const startupAlphaAmountRaisingOptions = [
  "Under $250,000",
  "$250,001 to $500,000",
  "$500,001 to $1,000,000",
  "$1,000,001 to $3,000,000",
  "Over $3,000,000",
] as const;

export const startupAlphaGoalOptions = [
  "Meet investors",
  "Find customers",
  "Find partners",
  "Hire talent",
  "Grow brand awareness and media coverage",
  "Get mentorship and feedback",
  "Pitch on stage",
] as const;
export const STARTUP_ALPHA_MAX_GOALS = 3;

// August 12, 2027 is a Thursday and August 13, 2027 is a Friday.
export const startupAlphaExpoDayOptions = [
  "Thursday, August 12, 2027",
  "Friday, August 13, 2027",
  "Either day",
] as const;

// "Are you raising capital now?" asks how much only on Yes.
export const STARTUP_ALPHA_RAISING_FIELD = "raisingCapital";
export const STARTUP_ALPHA_RAISING_FOLLOW_UP = "amountRaising";

export const STARTUP_ALPHA_CONFIRMATION =
  `Thanks for applying to ${STARTUP_ALPHA_NAME}. We review applications in batches and reply by email. Applications close ${STARTUP_ALPHA_CLOSES_ON}.`;

export function getStartupAlphaConfirmation(slug: string): string | undefined {
  return slug === STARTUP_ALPHA_FORM_SLUG ? STARTUP_ALPHA_CONFIRMATION : undefined;
}
